"use client";

import Button from "@/components/design-system/button";
import { useGetUserQuery } from "@/store/userApi";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
import styles from "./createAccount.module.scss";

interface CreateAccountProps {
  /** When true, the inner content spans the full page width instead of being capped at the header's 1440px width. */
  fullWidth?: boolean;
}

export default function CreateAccount({ fullWidth = false }: CreateAccountProps) {
  const { data: user, isLoading: userIsLoading } = useGetUserQuery();
  const pathname = usePathname();

  const createAccountURL = useMemo(() => {
    if (pathname) {
      return "/create-account?origin=" + encodeURIComponent(pathname as string);
    } else {
      return "/create-account";
    }
  }, [pathname]);

  if (userIsLoading === false && user?.IsGuestUser !== false) {
    return (
      <div className={styles.createAccountSection}>
        <div className={`${styles.createAccountWrapper} ${fullWidth ? styles.fullWidth : ""}`}>
          <div className={styles.getStartedText}>
            <span>
              <h2 className={styles.headerText}>Ready to get started?</h2>
            </span>
            <span className={styles.descriptionText}>Sign up (it&apos;s free) in under 30 seconds.</span>
          </div>
          <Link href={createAccountURL}>
            <Button variant="primary" color="teal" text="Sign Up" showLeftIcon={false} />
          </Link>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
